import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BlockLoadingComponent } from '@merchant-portal/app/components/loading/block-loading/block-loading.component';
import { NgxCurrencyDirective } from 'ngx-currency';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { BreadcrumbComponent } from 'projects/merchant-portal/src/app/components/breadcrumb/breadcrumb.component';
import { SingleTransactionComponent } from './single-transaction.component';

@NgModule({
  declarations: [SingleTransactionComponent],
  imports: [
    RouterModule,
    CommonModule,
    InputTextModule,
    ReactiveFormsModule,
    ButtonModule,
    SelectModule,
    TextareaModule,
    BreadcrumbComponent,
    NgxCurrencyDirective,
    BlockLoadingComponent,
    InputGroupModule,
    InputGroupAddonModule,
  ],
  exports: [SingleTransactionComponent],
})
export class SingleTransactionModule {}
